<div class="unauth-container">
  <div class="unauth-view-wrapper">
      <div class="unauthorized-msg-wrapper">
          <div class="top-border"></div>
          <div class="msg-section">
            <div class="icon-wrapper">
                <span class='csx-common_stop'></span>
            </div>
            <div class="unauthorized-msg">
              <p>Oops! Looks like you are not authorized to view this page.</p>
              <p *ngIf="adminEmail">Contact <a href="mailto:{{adminEmail}}">system admin</a> to request access.</p>
            </div>
          </div>
      </div>
  </div>
</div>
